import { useRemoveUserFromTenant } from '@/hooks/queries/users';
import { User } from '@/types/user';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';

interface RemoveFromTenantModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: User | null;
}

export default function RemoveFromTenantModal({
  isOpen,
  onClose,
  user,
}: RemoveFromTenantModalProps) {
  const { mutate: removeFromTenant, isPending } = useRemoveUserFromTenant({
    onSuccess: onClose,
  });

  const handleConfirm = () => {
    if (!user) return;
    removeFromTenant(user.id);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalContent>
        <ModalHeader>Remove from tenant</ModalHeader>
        <ModalBody className="gap-3">
          <p className="text-sm text-default-600">
            This will remove{' '}
            <span className="font-medium text-default-900">
              {user?.email ?? 'this user'}
            </span>
            &apos;s access to the current tenant. Their account and access to
            other tenants will not be deleted.
          </p>
        </ModalBody>
        <ModalFooter className="justify-between border-t mt-4">
          <Button variant="bordered" onPress={onClose} isDisabled={isPending}>
            Cancel
          </Button>
          <Button color="primary" onPress={handleConfirm} isLoading={isPending}>
            Remove From Tenant
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
